import { ChevronDown } from "lucide-react"
import { useEffect, useRef, useState } from "react"

const CreateSelect = ({ value, options, onChange, disabled = false }) => {
  const ref = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  const selectedOption = options.find((option) => {
    const optionValue = option.value ?? option

    return optionValue === value
  })

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!ref.current?.contains(e.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={`
        relative
        w-full rounded-xl bg-slate-50
        outline-none transition
        `}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={() => setIsOpen((prev) => !prev)}
        className={`
          flex w-full items-center justify-between
          px-4 py-3 rounded-xl
          transition-colors

          ${
            disabled
              ? "cursor-default text-slate-400"
              : `
                cursor-pointer
                hover:bg-blue-100
                text-slate-700
              `
          }
        `}
      >
        <span className="font-medium">{selectedOption?.label ?? selectedOption ?? ""}</span>

        {!disabled && (
          <span
            className={`
              text-slate-600
              transition-transform
              ${isOpen ? "rotate-180" : ""}
            `}
          >
            <ChevronDown size={18} />
          </span>
        )}
      </button>

      {!disabled && isOpen && (
        <ul
          className="
            absolute left-0 top-full z-20 mt-2
            w-full overflow-hidden
            rounded-lg border border-sky-100
            bg-white shadow-lg
          "
        >
          {options.map((option) => {
            const optionValue = option.value ?? option
            const optionLabel = option.label ?? option

            const isSelected = value === optionValue

            return (
              <li key={optionValue}>
                <button
                  type="button"
                  onClick={() => {
                    onChange(optionValue)
                    setIsOpen(false)
                  }}
                  className={`
                    w-full px-4 py-3 text-left
                    transition-colors

                    ${
                      isSelected
                        ? `
                          bg-blue-100
                          text-sky-800
                          font-semibold
                        `
                        : `
                          text-slate-700
                          hover:bg-blue-50
                        `
                    }
                  `}
                >
                  {optionLabel}
                </button>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default CreateSelect
